// ESS Toolbox Data - Mock data for sentence structure analysis
export const essToolboxData = {
  // Sample passages for analysis
  samplePassages: [
    {
      id: 'passage_1',
      title: 'Customer Service Response',
      content: `When our display books are in poor condition, we of course would try to offer a new copy of these books to our customers. However, if a new copy is unavailable, we would offer a display copy at a discounted price. I believe the member of staff who served you is new, and was at that time unaware of these policies. We try and ensure that our service is always the best we can offer. I therefore agree that staff rolling their eyes at you and making you feel uncomfortable is quite unacceptable. Please do accept my sincerest apologies for the poor service you experienced. I would like to assure you that the staff member in question has been brought up-to-date on our service expectations. In addition, he has been thoroughly briefed on the standards of service our customers expect to receive. As a gesture of goodwill, I have enclosed a HK$100 book voucher for our bookshop.`
    },
    {
      id: 'passage_2',
      title: 'Academic Writing Sample',
      content: `The research findings indicate that students who participate in extracurricular activities demonstrate higher academic performance than those who do not. Furthermore, these students develop better time management skills and social competencies. The study involved over 500 participants from various educational institutions. Data collection methods included surveys, interviews, and academic records analysis. Results showed a significant correlation between extracurricular participation and academic achievement.`
    },
    {
      id: 'passage_3',
      title: 'Environmental Report',
      content: `Climate change poses significant challenges to global ecosystems and human societies. Scientists have observed unprecedented temperature increases over the past century. These changes affect weather patterns, sea levels, and biodiversity worldwide. Governments must implement comprehensive policies to address these environmental concerns. International cooperation is essential for effective climate action.`
    }
  ],

  // Predefined sentence structure patterns
  sentencePatterns: {
    'S+V': {
      name: 'Subject + Verb',
      chineseName: '主詞 + 動詞',
      description: 'The simplest sentence pattern with just a subject and verb',
      examples: ['Birds fly.', 'Students study.', 'Time passes.']
    },
    'S+V+O': {
      name: 'Subject + Verb + Object',
      chineseName: '主詞 + 動詞 + 受詞',
      description: 'Pattern with a subject, verb, and direct object',
      examples: ['She likes apples.', 'They read books.', 'We offer services.']
    },
    'S+V+C': {
      name: 'Subject + Verb + Complement',
      chineseName: '主詞 + 動詞 + 補語',
      description: 'Pattern with a subject, linking verb, and complement',
      examples: ['My father is a doctor.', 'The weather becomes cold.', 'She looks tired.']
    },
    'S+V+IO+DO': {
      name: 'Subject + Verb + Indirect Object + Direct Object',
      chineseName: '主詞 + 動詞 + 間接受詞 + 直接受詞',
      description: 'Pattern with two objects - indirect and direct',
      examples: ['She told me a story.', 'He gave her flowers.', 'We offer customers books.']
    },
    'S+V+O+C': {
      name: 'Subject + Verb + Object + Complement',
      chineseName: '主詞 + 動詞 + 受詞 + 補語',
      description: 'Pattern with object and object complement',
      examples: ['They elected him president.', 'She made me happy.', 'We found the room empty.']
    }
  },

  // Mock quiz questions
  mockQuizQuestions: [
    {
      id: 1,
      question: "What is the sentence pattern of 'When our display books are in poor condition, we of course would try to offer a new copy of these books to our customers'?",
      options: [
        { text: "S+V+O+IO (情態+不定詞+受詞+受益對象)", isCorrect: true },
        { text: "S+V+C (連綴動詞+形容詞補語)", isCorrect: false },
        { text: "S+V+O (及物動詞)", isCorrect: false },
        { text: "S+V+Adv (存在句)", isCorrect: false }
      ],
      explanation: "正確! 主句「we of course would try to offer a new copy... to our customers」包含主詞(we)、情態助動詞(would)、動詞(try to offer)、受詞(a new copy...)和受益對象(to our customers)。前面的when子句是條件狀語,主句屬於「S+V+O+IO」結構,具體分析為「情態+不定詞+受詞+受益對象」。"
    },
    {
      id: 2,
      sentence: "However, if a new copy is unavailable, we would offer a display copy at a discounted price.",
      question: "What is the main sentence pattern?",
      options: [
        { text: "S+V+C (連綴動詞+形容詞補語)", isCorrect: false },
        { text: "S+V+O+Adv (情態+及物動詞+受詞+狀語)", isCorrect: true },
        { text: "S+V+O (及物動詞)", isCorrect: false },
        { text: "S+V+O+C (受詞補語)", isCorrect: false }
      ],
      explanation: "正確！主句「we would offer a display copy at a discounted price」是S(we)+V(would offer)+O(a display copy)+Adv(價格狀語)。if子句是條件狀語。"
    },
    {
      id: 3,
      sentence: "I believe the member of staff who served you is new, and was at that time unaware of these policies.",
      question: "What is the structure of the main clause?",
      options: [
        { text: "S+V+O (及物動詞+受詞)", isCorrect: true },
        { text: "S+V+C (連綴動詞+補語)", isCorrect: false },
        { text: "S+V+IO+DO (雙受詞)", isCorrect: false },
        { text: "S+V+Adv (不及物動詞+狀語)", isCorrect: false }
      ],
      explanation: "正確！主句「I believe the member of staff...」是S(I)+V(believe)+O(the member of staff...)，其中包含定語從句「who served you」。"
    },
    {
      id: 4,
      sentence: "We try and ensure that our service is always the best we can offer.",
      question: "What is the main sentence pattern?",
      options: [
        { text: "S+V+O (及物動詞+受詞)", isCorrect: true },
        { text: "S+V+C (連綴動詞+補語)", isCorrect: false },
        { text: "S+V+IO+DO (雙受詞)", isCorrect: false },
        { text: "S+V+Adv (不及物動詞+狀語)", isCorrect: false }
      ],
      explanation: "正確！主句「We try and ensure that...」是S(We)+V(try and ensure)+O(that our service is...)，其中包含賓語從句。"
    },
    {
      id: 5,
      sentence: "I would like to assure you that the staff member in question has been brought up-to-date on our service expectations.",
      question: "What is the structure of this sentence?",
      options: [
        { text: "S+V+O (及物動詞+賓語從句)", isCorrect: true },
        { text: "S+V+C (連綴動詞+補語)", isCorrect: false },
        { text: "S+V+IO+DO (雙受詞)", isCorrect: false },
        { text: "S+V+Adv (不及物動詞+狀語)", isCorrect: false }
      ],
      explanation: "正確！主句「I would like to assure you that...」是S(I)+V(would like to assure)+O(you)+O(that the staff member...)，包含雙賓語結構。"
    }
  ],

  // Mock rewrite exercises
  mockRewriteExercises: [
    {
      id: 1,
      sentence: "When our display books are in poor condition, we of course would try to offer a new copy of these books to our customers.",
      examples: {
        'S+V': 'We try.',
        'S+V+O': 'We offer books.',
        'S+V+C': 'We are helpful.',
        'S+V+IO+DO': 'We give customers books.',
        'S+V+O+C': 'We make books available.',
        '其他': 'There are many books available.'
      },
      instructions: {
        'S+V': '請將句子改寫為最簡單的主詞+動詞結構，描述基本動作或狀態。',
        'S+V+O': '請將句子改寫為主詞+動詞+受詞的結構，突出動作的對象。',
        'S+V+C': '請將句子改寫為主詞+動詞+補語的結構，描述狀態或屬性。',
        'S+V+IO+DO': '請將句子改寫為雙受詞結構，明確指出受益者和動作對象。',
        'S+V+O+C': '請將句子改寫為受詞補語結構，描述受詞的狀態或特徵。',
        '其他': '請將句子改寫為存在句（There is/are...）、祈使句或條件句（If...）。'
      }
    },
    {
      id: 2,
      sentence: "However, if a new copy is unavailable, we would offer a display copy at a discounted price.",
      examples: {
        'S+V': 'We offer.',
        'S+V+O': 'We offer copies.',
        'S+V+C': 'We are generous.',
        'S+V+IO+DO': 'We give customers copies.',
        'S+V+O+C': 'We make copies affordable.',
        '其他': 'There are discounted copies available.'
      },
      instructions: {
        'S+V': '請將句子改寫為最簡單的主詞+動詞結構，描述基本動作或狀態。',
        'S+V+O': '請將句子改寫為主詞+動詞+受詞的結構，突出動作的對象。',
        'S+V+C': '請將句子改寫為主詞+動詞+補語的結構，描述狀態或屬性。',
        'S+V+IO+DO': '請將句子改寫為雙受詞結構，明確指出受益者和動作對象。',
        'S+V+O+C': '請將句子改寫為受詞補語結構，描述受詞的狀態或特徵。',
        '其他': '請將句子改寫為存在句（There is/are...）、祈使句或條件句（If...）。'
      }
    },
    {
      id: 3,
      sentence: "I believe the member of staff who served you is new, and was at that time unaware of these policies.",
      examples: {
        'S+V': 'I believe.',
        'S+V+O': 'I believe the staff member.',
        'S+V+C': 'I am confident.',
        'S+V+IO+DO': 'I tell you the truth.',
        'S+V+O+C': 'I find the situation concerning.',
        '其他': 'There is a new staff member.'
      },
      instructions: {
        'S+V': '請將句子改寫為最簡單的主詞+動詞結構，描述基本動作或狀態。',
        'S+V+O': '請將句子改寫為主詞+動詞+受詞的結構，突出動作的對象。',
        'S+V+C': '請將句子改寫為主詞+動詞+補語的結構，描述狀態或屬性。',
        'S+V+IO+DO': '請將句子改寫為雙受詞結構，明確指出受益者和動作對象。',
        'S+V+O+C': '請將句子改寫為受詞補語結構，描述受詞的狀態或特徵。',
        '其他': '請將句子改寫為存在句（There is/are...）、祈使句或條件句（If...）。'
      }
    }
  ],

  // Detailed sentence structure analysis templates
  structureAnalysisTemplates: {
    'S+V+O+IO': {
      mainType: 'S + (Adv) + Modal + V + to V + O + to + IO',
      basicStructure: '（基礎型：S+V+O+IO）',
      details: '情態助動詞 + 不定詞片語 + 受詞 + 受益對象',
      subclauses: [
        '插入副詞（of course）',
        '不定詞片語（to offer...）',
        'to+受詞（to our customers）'
      ]
    },
    'S+V+O+Adv': {
      mainType: 'S + Modal + V + O + Adv',
      basicStructure: '（基礎型：S+V+O+Adv）',
      details: '情態助動詞 + 及物動詞 + 受詞 + 狀語',
      subclauses: [
        '情態助動詞（would）',
        '及物動詞（offer）',
        '價格狀語（at a discounted price）'
      ]
    },
    'S+V+O': {
      mainType: 'S + V + O',
      basicStructure: '（基礎型：S+V+O）',
      details: '及物動詞 + 受詞',
      subclauses: [
        '及物動詞（believe）',
        '賓語從句（that...）'
      ]
    }
  },

  // Tree visualization data
  treeVisualizationData: [
    {
      id: 1,
      sentence: "When our display books are in poor condition, we of course would try to offer a new copy of these books to our customers.",
      analysis: {
        mainType: 'S + (Adv) + Modal + V + to V + O + to + IO',
        basicStructure: '（基礎型：S+V+O+IO）',
        details: '情態助動詞 + 不定詞片語 + 受詞 + 受益對象',
        subclauses: [
          '插入副詞（of course）',
          '不定詞片語（to offer...）',
          'to+受詞（to our customers）'
        ]
      },
      conditionClause: {
        content: 'our display books are in poor condition',
        type: 'S + V + C',
        description: '連綴動詞 + 形容詞片語'
      }
    },
    {
      id: 2,
      sentence: "However, if a new copy is unavailable, we would offer a display copy at a discounted price.",
      analysis: {
        mainType: 'S + Modal + V + O + Adv',
        basicStructure: '（基礎型：S+V+O+Adv）',
        details: '情態助動詞 + 及物動詞 + 受詞 + 狀語',
        subclauses: [
          '情態助動詞（would）',
          '及物動詞（offer）',
          '價格狀語（at a discounted price）'
        ]
      },
      conditionClause: {
        content: 'a new copy is unavailable',
        type: 'S + V + C',
        description: '連綴動詞 + 形容詞補語'
      }
    },
    {
      id: 3,
      sentence: "I believe the member of staff who served you is new, and was at that time unaware of these policies.",
      analysis: {
        mainType: 'S + V + O',
        basicStructure: '（基礎型：S+V+O）',
        details: '及物動詞 + 賓語從句',
        subclauses: [
          '及物動詞（believe）',
          '賓語從句（that...）',
          '定語從句（who served you）'
        ]
      },
      conditionClause: null
    }
  ]
};

export default essToolboxData; 